import { render, staticRenderFns } from "./UnionPayCupsMerchant.vue?vue&type=template&id=ed518e94&scoped=true&"
import script from "./UnionPayCupsMerchant.vue?vue&type=script&lang=js&"
export * from "./UnionPayCupsMerchant.vue?vue&type=script&lang=js&"
import style0 from "./UnionPayCupsMerchant.vue?vue&type=style&index=0&id=ed518e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed518e94",
  null
  
)

export default component.exports